export { default as TermsConditions } from './term-condition-modal';
export { default as SignUp } from './sign-up-modal';
export { default as PdfContent } from './pdfContent';
export { default as RmCallBack } from './rm-callback';
export { default as TermsConditionLUX } from './lux-modals-for-login';
export { default as RegisterNewDevice } from './register-new-device';
